import Apiservice from '@/core/services/api.service';
import {API_URL} from '@/common/config.js'

const apiService = Apiservice;


export default class AttendanceService {

    #api = null;

    constructor() {
        this.#api = `${API_URL}user/attendance`;
    }

    store(data) {
        let url = `${this.#api}`
        return apiService.post(url, data);
    }

    update(id, data) {
        let url = `${this.#api}/${id}`
        return apiService.put(url, data);
    }

    index(data) {
        let url = `${this.#api}`
        let param = {
            params: data
        }
        return apiService.query(url, param)
    }

    getReport(data, index = null) {
        let url = `${this.#api}-report`;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }

    gePendingAttendance(data, index = null) {
        let url = `${this.#api}-pending`;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }

    getAttendanceReport(data) {
        let url = `${this.#api}/get-report`;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }

    getSummaryReport(data) {
        let url = `${this.#api}/summary-report`;
        let param = {
            params: data
        }
        return apiService.query(url, param);
    }

    attendanceReportById(id) {
        let url = `${this.#api}/${id}/student-report`;
        return apiService.get(url);
    }

}